import React, { useCallback } from 'react'
import {
  TitleDescContainer,
  TitleWrapper,
  DescWrapper,
  ItemWrapper,
} from '~/app/components/Cart/CartGroup/CartGroup.style'
import DomesticTrainItem, { TrainOption } from '~/app/components/Cart/CartItem/DomesticTrainItem'

/**
 * DomesticTrainGroup component
 * author: jaegeunlee
 * description
 */
interface DomesticTrainGroupProps {
  representativeName: string
  options: TrainOption[]
  isTrainPackageDiscountAvailable: boolean
  onCheck?: (checked: boolean, id: string) => void
  onClose?: (id: string) => void
  onTitleClick?: (id: string) => void
  onCancelRefreshButtonClick?: () => void
}

const DomesticTrainGroup: React.FC<DomesticTrainGroupProps> = props => {
  const onGroupTitleClick = useCallback(() => {
    props.onTitleClick?.(props.options?.[0]?.id)
  }, [props.options])

  return (
    <>
      <TitleDescContainer>
        <TitleWrapper onClick={onGroupTitleClick}>{props.representativeName}</TitleWrapper>
        <DescWrapper>{'교통'}</DescWrapper>
      </TitleDescContainer>
      {props.options.map(option => (
        <ItemWrapper key={option.id}>
          {option.__typename === 'DomesticTrainCartItemOption' && (
            <DomesticTrainItem
              option={option}
              onCheck={props.onCheck}
              onClose={props.onClose}
              onTitleClick={props.onTitleClick}
              onCancelRefreshButtonClick={props.onCancelRefreshButtonClick}
            />
          )}
        </ItemWrapper>
      ))}
    </>
  )
}

export default DomesticTrainGroup
